import React, { useState } from 'react';
import '../css/navbar.css';

import { Link } from 'react-router-dom';
import logo from '../images/footer/logo.png';
import logo1 from '../images/footer/logo1.jpg';
import yeastarLogo from '../images/intro/Yeastar_Logo.png';
import yealinkLogo from '../images/intro/Yealink-LOGO-Green.png';
import yeastarFeatured1 from '../images/yeastar/s50.webp';
import yeastarFeatured2 from '../images/yeastar/p560.webp';
import yeastarFeatured3 from '../images/yeastar/t400.webp';
import yealinkFeatured1 from '../images/yealink/t88.webp';
import yealinkFeatured2 from '../images/yealink/t54w.webp';
import yealinkFeatured3 from '../images/yealink/t42u.webp';

import { Button, Typography, Popover, Box } from '@mui/material';
import { ArrowOutward } from '@mui/icons-material';

const BRANDS = [
  { id: 'yeastar', name: 'Yeastar', path: '/yeastar-products', logo: yeastarLogo, featured: [yeastarFeatured1, yeastarFeatured2, yeastarFeatured3] },
  { id: 'yealink', name: 'Yealink', path: '/yealink-products', logo: yealinkLogo, featured: [yealinkFeatured1, yealinkFeatured2, yealinkFeatured3] },
];

export const Navbar = ({ sectionId, label }) => {
  const [menuopen, setMenuopen] = useState(false);
  const [animateOut, setAnimateOut] = useState(false);
  const [productsOpen, setProductOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [hoveredBrand, setHoveredBrand] = useState(null);

  function handleMenuToggle() {
    if (menuopen) {
      setAnimateOut(true);
      setTimeout(() => setAnimateOut(false), 1500);
    }
    setMenuopen(!menuopen);
  }

  const handleClick = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => {
    setAnchorEl(null);
    setHoveredBrand(null);
  };
  const toggleProductsDropdown = () => setProductOpen(!productsOpen);
 

  return (
    <div className='nav-container'>
      <div className='nav-logolg' >
        <Link to='/' aria-label="Advance Resources Home">
        <img src={logo} alt="Advance Resources Logo" width="200" height="60" loading="eager" />
        </Link>
      </div>
      <div className='nav-logosm' >
        <Link to='/' aria-label="Advance Resources Home">
        <img src={logo1} alt="Advance Resources Logo" width="150" height="45" loading="eager" />
        </Link>
        
      </div>
      <input
        className='menu-btn'
        type='checkbox'
        id='menu-btn'
        checked={menuopen}
        onChange={handleMenuToggle}
      />
      <label className='menu-icon' htmlFor='menu-btn'>
        <span className='nav-icon'></span>
      </label>
      <div className={`nav-items ${animateOut ? 'slide-out' : menuopen ? 'slide-in' : ''}`}>
       
      <Link to="/"> <Typography variant='h1' component="span" sx={{ fontSize:'16px',fontWeight:500,color:'secondary.dark','&:hover': {color:'secondary.light'}, marginRight: '14px'}} onClick={() => window.scrollTo(0, 0)} >Home</Typography></Link>
       
        
      <Link to="/Aboutpage"> <Typography variant='h1' component="span" sx={{fontSize:'16px', fontWeight:500,color:'secondary.dark','&:hover': {color:'secondary.light'}, marginRight: '14px'}}  onClick={() => window.scrollTo(0, 0)}>About</Typography></Link>
        
       
     
        {/* large screen */}
    <Button
          aria-controls="products-menu"
          aria-haspopup="true"
          onClick={handleClick}

          sx={{display:{xs:'none',lg:'block'},border:'none',backgroundColor:'transparent', textTransform:'none',fontSize: '16px', fontWeight: 500, color: 'secondary.dark', '&:hover': { backgroundColor:'transparent',color: 'secondary.light' },'&:onClick':{backgroundColor:'transparent'}, marginRight: '12px' }}
        >
          Products
        </Button>
        <Popover
          id="products-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          container={document.body}
          disableScrollLock
          sx={{ mt: '8px' }}
          slotProps={{
            paper: {
              sx: {
                borderRadius: 2,
                boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                width: '68vw',
                minWidth: 480,
                maxWidth: 1000,
                minHeight: '52vh',
                maxHeight: '62vh',
                p: 2.5,
              },
            },
          }}
        >
          <Box sx={{ display: 'flex', minHeight: '44vh', gap: 0 }}>
            {/* Left column: BRANDS */}
            <Box sx={{ width: 260, borderRight: '1px solid', borderColor: 'divider', py: 2, pr: 3, pl: 0.5 }}>
              <Typography variant="overline" sx={{ px: 2, mb: 2, display: 'block', fontWeight: 700, color: 'text.secondary', letterSpacing: 1 }}>
                BRANDS
              </Typography>
              {BRANDS.map((brand) => (
                <Link key={brand.id} to={brand.path} style={{ textDecoration: 'none' }} onClick={handleClose}>
                  <Box
                    onMouseEnter={() => setHoveredBrand(brand.id)}
                    onMouseLeave={() => setHoveredBrand(null)}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      px: 2,
                      py: 2,
                      '&:hover': { backgroundColor: 'action.hover' },
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <img src={brand.logo} alt="" style={{ width: 36, height: 36, objectFit: 'contain' }} />
                      <Box>
                        <Typography variant="body1" sx={{ fontWeight: 600, color: 'text.primary' }}>{brand.name}</Typography>
                        <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>Explore products</Typography>
                      </Box>
                    </Box>
                    <ArrowOutward sx={{ fontSize: 18, color: 'primary.main' }} />
                  </Box>
                </Link>
              ))}
              <Link to="/yealink-products" style={{ textDecoration: 'none' }} onClick={handleClose}>
                <Typography variant="body2" sx={{ px: 2, pt: 2.5, pb: 0.5, fontWeight: 600, color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
                  View all Products
                </Typography>
              </Link>
            </Box>
            {/* Right column: Featured products — each card 1/3 width, even padding */}
            <Box sx={{ flex: 1, px: 3, py: 2.5, pl: 4, backgroundColor: 'grey.50', display: 'flex', flexDirection: 'column' }}>
              {(() => {
                const active = hoveredBrand ? BRANDS.find((b) => b.id === hoveredBrand) : BRANDS[0];
                return (
                  <>
                    <Typography variant="overline" sx={{ mb: 2, display: 'block', fontWeight: 600, color: 'text.secondary', letterSpacing: 0.5 }}>
                      {active.name.toUpperCase()}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, mt: 2, flex: 1, minWidth: 0 }}>
                      {active.featured.map((img, i) => (
                        <Box
                          key={i}
                          sx={{
                            flex: '1 1 0',
                            minWidth: 0,
                            aspectRatio: '1',
                            borderRadius: 1.5,
                            overflow: 'hidden',
                            backgroundColor: 'white',
                            boxShadow: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: 1.5,
                          }}
                        >
                          <img src={img} alt="" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                        </Box>
                      ))}
                    </Box>
                  </>
                );
              })()}
            </Box>
          </Box>
        </Popover>
     
     <Button
         
          // changing dropdown in display
          sx={{ display:{lg:'none !important'},border:'none',backgroundColor:'transparent', textTransform:'none',fontSize: '18px', fontWeight: 500, color: 'secondary.dark', '&:hover': { backgroundColor:'transparent',color: 'secondary.light' },'&:onClick':{backgroundColor:'transparent'}, marginRight: '12px' }}
          onClick={toggleProductsDropdown}
       >
          Products
        </Button>
          {productsOpen && (
            // changing dropdown css in mobile view and desktop view
          <div style={{display:{xs:'block',lg:'none !important'},justifyContent:'center', textAlign:'center',width:'100%'}}>
      <Link  to="/yeastar-products"  onClick={() => setProductOpen(false)}>
              <Typography  variant='h1' sx={{ fontSize: '16px', fontWeight: 500, color: 'secondary.dark', '&:hover': { color: 'secondary.light' } }}>Yeastar</Typography>
            </Link>
            <Link to="/yealink-products" onClick={() => setProductOpen(false)}>
              <Typography  variant='h1' sx={{ fontSize: '16px', fontWeight: 500, color: 'secondary.dark', '&:hover': { color: 'secondary.light' } }}>Yealink</Typography>
            </Link>
          </div>
)}
      
      <Link to="/Servicespage"> <Typography variant='h1'component="span" onClick={() => window.scrollTo(0, 0)} sx={{ fontSize:'16px',fontWeight:500,color:'secondary.dark','&:hover': {color:'secondary.light'}, marginRight: '12px'}}>Services</Typography></Link>
      <Link to="/seo-services"> <Typography variant='h1'component="span" onClick={() => window.scrollTo(0, 0)} sx={{ fontSize:'16px',fontWeight:500,color:'secondary.dark','&:hover': {color:'secondary.light'}, marginRight: '12px'}}>SEO</Typography></Link>
      <Link to="/blog"> <Typography variant='h1'component="span" onClick={() => window.scrollTo(0, 0)} sx={{ fontSize:'16px',fontWeight:500,color:'secondary.dark','&:hover': {color:'secondary.light'}, marginRight: '12px'}}>Blog</Typography></Link>
      <Link to="/Contactpage"> <Typography variant='h1' component="span" onClick={() => window.scrollTo(0, 0)} sx={{  display: { md : 'none !important' }, fontSize:'16px',fontWeight:500,color:'secondary.dark','&:hover': {color:'secondary.light'}, marginRight: '18px'}} >Contact</Typography></Link>
       
      
       
      </div>
      
      <div className='nav-button'>
     
                <Button variant="contained" component={Link} to='/Contactpage' onClick={() => window.scrollTo(0, 0)}  endIcon={<ArrowOutward sx={{paddingBottom:0.2}}/>} aria-label="Contact us for IT solutions" sx={{border: '1px solid #E3F0FF', color:'secondary.dark',
  borderRadius: 10,
  width:200,
  backgroundColor: 'secondary.main',
 
  padding:'10px 10px',
  fontSize:'14px',
  textAlign:'center',
  justifyContent:'center',
 
 
  boxShadow:'none',
  '&:hover': {
    backgroundColor: 'secondary.light',
    borderColor:'secondary.light',
    color:'secondary.main',
    
   padding:'10px',
   fontSize:'14px',}}}>Contact Us</Button>
     
      </div>
      
       
     
    </div>
  );
};






